export default __webpack_public_path__ + "static/media/back.95ea8172.svg";